/**
 * Adds a loading spinner to the target, if it doesn't already have one.
 * @param {HTMLElement | undefined} target
 * @param {string} [message]
 * @param {string} [customMessageClass]
 */
export function showSpinner(target, message, customMessageClass) {
    if (!target) {
        return;
    }

    BINamespace.LoadingSpinner.Show(target, message, customMessageClass);
}

/**
 * Adds a loading spinner to the target, if it doesn't already have one.
 * @param {HTMLElement | undefined} target
 */
export function hideSpinner(target) {
    if (!target) {
        return;
    }

    BINamespace.LoadingSpinner.Hide(target);
}